/**
 * 变量定义规则  {模块名(SYS)}_{接口地址}_{请求方式(GET、POST)} （全大写）
 * @type {string | undefined}
 */


// export const CONTEXT = './api';
const CONTEXT = process.env.VUE_APP_REQUEST_BASE_URL_PROXY;


export const USER_SEND_VCODE = CONTEXT + '/api/v1/customer/send/vcode';
export const USER_LOGIN = CONTEXT + '/api/v1/customer/login/vcode';
export const USER_IS_LOGIN = CONTEXT + '/api/v1/customer/isLogin';
export const USER_LOGOUT = CONTEXT + '/api/v1/customer/logout';
export const VIDEO_LIST = CONTEXT + '/api/v1/video/videoList';
export const VIDEO_HOT_NAME_LIST = CONTEXT + '/api/v1/video/hotVideoNameList';
export const VIDEO_DETAIL = CONTEXT + '/api/v1/video/videoDetail';
export const VIDEO_LIST_FOR_DETAIL = CONTEXT + '/api/v1/video/videoListForDetail';
export const CHANNEL_LIST = CONTEXT + '/api/v1/channel/list';

export const ADVERTISEMENT_LIST = CONTEXT + '/api/v1/advertisement/list';

